import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { TextButtonCell } from '~/components/common';

import { formatDate } from '~/utils/date';

import { VENDER_DATE_FORMAT } from '~/constants';

import type { TypeVenderSupplier } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 공급사 관리] 테이블
 */
const getVenderSupplierColumnDefs = ({
  onClickViewDetail,
}: {
  onClickViewDetail: (data: TypeVenderSupplier) => Promise<void>;
}) => {
  const columnDefs: TypeTableColumn<TypeVenderSupplier>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'ownerSupplierName',
      header: '공급사명',
      size: 180,
    },
    {
      accessorKey: 'ownerSupplierCode',
      header: '공급사코드',
      size: 120,
    },
    {
      accessorKey: 'createdAt',
      header: '등록일',
      size: 100,
      cell: ({ getValue }) => formatDate(getValue<string>(), VENDER_DATE_FORMAT.DATE) ?? '-',
    },
    {
      accessorKey: 'modifiedAt',
      header: '수정일',
      size: 100,
      cell: ({ getValue }) => formatDate(getValue<string>(), VENDER_DATE_FORMAT.DATE) ?? '-',
    },
    {
      accessorKey: 'useStatus',
      header: '사용여부',
      size: 80,
      cell: ({ getValue }) => (getValue<'Y' | 'N'>() === 'Y' ? '사용' : '사용안함'),
    },
    {
      id: 'viewDetail',
      header: '',
      cell: ({ row }) => (
        <TextButtonCell showDashIfNoValue={false} onClick={() => onClickViewDetail(row.original)}>
          상세보기
        </TextButtonCell>
      ),
      meta: { flex: true },
    },
  ];

  return { columnDefs };
};

export default getVenderSupplierColumnDefs;
